export function fixedshare() {
    const target = document.querySelector(".l-footer");
    const fxdElm = document.querySelector(".l-fxdshare");

    if(!fxdElm) return;

    const option = {
        root: null,
        rootMargin: "0px",
        threshold: [0],
    };
    // 交差した際の処理を記載
    const callback = function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                fxdElm.classList.remove("-active");
            } else {
                fxdElm.classList.add("-active");
            }
        });
    };
    const observer = new IntersectionObserver(callback, option);
    observer.observe(target); // 監視を開始
}
